import { StateEnumLabel } from "./StateEnumLabel"

export const AccountStateColors: Record<StateEnumLabel, string> = {
    [StateEnumLabel.ACTIVE]: "green",
    [StateEnumLabel.INACTIVE]: "blue",
    [StateEnumLabel.ERROR]: "red",
    [StateEnumLabel.OUTDATED]: "orange",
    [StateEnumLabel.DEFAULT]: "gray",
}
